"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var britneyEgg = {
    name: "britney",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["b", "r", "i", "t", "n", "e", "y"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/EuhEYw8.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "250px";
        img.style.height = "180px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 125px)";
        img.style.bottom = "-149px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "0px";
        }, 50);
        window.setTimeout(function () {
            img.style.bottom = "-149px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            shock.parentNode.removeChild(shock);
        }, 5400);
    },
};
exports.default = britneyEgg;
